import { registraGlobalComponents } from '@/app'

import VApp from './VApp.vue'
import KTopo from './KTopo/KTopo.vue'
import NavBar from './NavBar/NavBar.vue'
import KMenu from './KMenu/KMenu.vue'
import KMenuItem from './KMenu/KMenuItem.vue'

registraGlobalComponents({
	VApp,
	KTopo,
	NavBar,
	KMenu,
	KMenuItem,
})
